import axios from "axios";
import config from "../../../config";

const apiUrl = config.api;

export interface Incident {
  guid: string;
  title: string;
  link: string;
  description: string;
  publishedDate: string;
  isResolved: boolean;
  monitorName: string;
  incidentType: string;
  resolvedDate: string | null;
  firstDetectedDate: string;
  taskStatus?: string;
  runTime?: string;
  lastEventLabel?: string;
}

export interface MonitoringFeed {
  incidents: Incident[];
  lastUpdated: string;
  feedTitle: string;
  lastBuildDate: string;
  totalIncidents: number;
  unresolvedCount: number;
}

export interface MonitoringResponse {
  results: MonitoringFeed[];
}

export const getMonitoringIncidents = async (): Promise<MonitoringResponse> => {
  const response = await axios.get<MonitoringResponse>(
    `${apiUrl}/monitoring/rss/incidents`,
    {
      params: { includeResolved: true },
    },
  );
  return response.data;
};

export const refreshMonitoringIncidents =
  async (): Promise<MonitoringResponse> => {
    const response = await axios.post<MonitoringResponse>(
      `${apiUrl}/monitoring/rss/refresh`,
    );
    return response.data;
  };
